import React from "react";
import Footer from "../../Footer/Footer";
import GetInTouch from "../../GetInTouch/GetInTouch";
import Header from "../Header/Header";
import HeaderMain from "../HeaderMain/HeaderMain";
import Projects from "../Projects/Projects";
import Services from "../Services/Services";

const Home = () => {
    return (
        <div className="container">
            <Header></Header>
            <HeaderMain></HeaderMain>
            <Services></Services>
            <Projects></Projects>
            <GetInTouch></GetInTouch>
            <Footer></Footer>
        </div>
    );
};

export default Home;
